module.exports = __webpack_public_path__ + "static/media/m3.e450a773.png";